var XPortal = XPortal || {};
XPortal.Numeric = (function () {
    var self = {
        ControlSelector: ".data-numeric, .data-numeric-readonly",
        Init: function (container) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            container.find(XPortal.Numeric.ControlSelector).each(function (ip, element) {
                XPortal.Numeric.initFor(XPortal.Store.getModelName(container[0].id), element);
            });
        },
        GetValue: function (el) {
            var ctrol = el ? el.data("kendoNumericTextBox") : null;
            var cval = ctrol ? ctrol.value() : null;
            return cval;
        },
        SetValue: function (el, val) {
            if (el && el.data("kendoNumericTextBox")) {
                if (XPortal.DefaultEditor.IsModified(el)) return;
                el.data("kendoNumericTextBox").value(val);
            }
        },
        initFor: function (modelName, element, isInlineEditor = false) {
            element = $(element);
            const sttgs = XPortal.Main.GetSettingsFor(element);
            const editorTypeLC = sttgs.type?.toLowerCase();
            sttgs.value = XPortal.Grid.ConvertToNumber(sttgs.value);
            if (!sttgs.format || sttgs.format.length < 1) sttgs.format = sttgs.mask || "n";
            if (element.attr("data-decimals")) sttgs.decimals = element.attr("data-decimals");
            if (sttgs.format && !sttgs.decimals === typeof undefined) {
                var nums = sttgs.format.match(/\d+/);
                if (nums) sttgs.decimals = parseInt(nums);
            }
            if (editorTypeLC == "int32" || editorTypeLC === "int64") {
                sttgs.restrictDecimals = true;
                sttgs.decimals = 0;
            }
            var txd = Number(element.attr("data-min"));
            if (!isNaN(txd)) sttgs.min = txd;
            txd = Number(element.attr("data-max"));
            if (!isNaN(txd)) sttgs.max = txd;
            txd = Number(element.attr("data-step"));
            if (!isNaN(txd)) sttgs.step = txd;


            const updateModel = function () {
                var xval = self.GetValue(element);
                XPortal.DefaultEditor.SetModification(element, xval);
                if (!isInlineEditor) {
                    element.trigger("dispatchFieldEvent");
                }
            };
            sttgs.change = updateModel;
            sttgs.spin = updateModel;

            element.kendoNumericTextBox(sttgs);
            if (isInlineEditor && element) $(element).attr("data-skip", "");
            if (!sttgs.editable) {
                var picker = element.data("kendoNumericTextBox");
                picker.enable(false);
                picker.readonly();
            }

            element.bind("dispatchFieldEvent", function (e) {
                var xval = self.GetValue(element);
                if (xval === null || isNaN(Number(xval))) xval = 0;

                XPortal.Store.FieldEvent(element, xval, modelName, sttgs);
            });

            XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: element },
                (value) => self.SetValue(element, value),
                (value) => self.GetValue(element)
            );
        }
    };
    return self;
}());
